import { render } from "./CobrConveniosTabPage.vue?vue&type=template&id=383a9fb0"
import script from "./CobrConveniosTabPage.vue?vue&type=script&lang=js"
export * from "./CobrConveniosTabPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__